// Charge la base commune
import './common.js'

// actions principales communes à toutes les pages
$(document).ready(function () {

})
